module.exports = __webpack_public_path__ + "img/default-student.6838224a.png";